import { object, string } from '~utils/validation'
import { Field, Modal, SubmitButton } from '~components'
import { Values } from './interfaces'
import * as Styled from './styled'
import { useState, useEffect } from 'react'
import { useNavigate, usePathValidation, useStore } from '~hooks'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { track } from '@amplitude/analytics-browser'

function Rntrc() {
  const handleShowValidation = (value: string) => value.length > 7
  const schema = object({
    rntrc: string().rntrc('RNTRC inválido.'),
  })
  const navigate = useNavigate()
  const { update, ...store } = useStore()
  const defaultValues = {
    rntrc: store.register?.rntrc || '',
  }
  const [openModal, setOpenModal] = useState(false)
  const modalButton = {
    onClick: handleClickCloseModal,
    text: 'Ok, entendi',
  }
  const {
    register,
    handleSubmit,
    watch,
    formState: { isValid, errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema), mode: 'onChange' })

  const rntrc = watch('rntrc')

  useEffect(() => {
    track('cadastro_rntrc', { tipo_veiculo: store.register.vehicleType })
  }, [])

  useEffect(() => {
    if (errors.rntrc && rntrc.length === 9) {
      track('cadastro_login_cpf', { errormessage: 'rntrc_invalido' })
    }
  }, [errors, rntrc])

  usePathValidation(['cpf', 'plate', 'register.cellphone', 'register.fullName'])
  useEffect(() => {
    update({ register: { progress: 40 } })
  }, [update])

  function onSubmit(values: Values) {
    update({ register: values })
    navigate('/cadastrar/tipo-carroceria', {
      state: { previousPath: '/cadastrar/rntrc' },
    })
  }
  function handleClickWhereToFindThisNumber() {
    setOpenModal(true)
  }
  function handleClickCloseModal() {
    setOpenModal(false)
  }

  return (
    <>
      <form aria-labelledby="form-rntrc" onSubmit={handleSubmit(onSubmit)}>
        <Styled.Title>Digite o RNTRC do veículo</Styled.Title>
        <Field
          defaultValue={defaultValues.rntrc}
          showSuccess
          autoFocus
          mask="999999999"
          name="rntrc"
          label="RNTRC (ANTT)"
          type="tel"
          whenShowValidation={handleShowValidation}
          error={errors.rntrc}
          isValid={isValid}
          register={register}
        />
        <SubmitButton width="100%" key="submit-button" disabled={!isValid}>
          Continuar
        </SubmitButton>
        <Styled.LinkButton color="tertiary" onClick={handleClickWhereToFindThisNumber}>
          Onde encontro esse número?
        </Styled.LinkButton>
      </form>
      <Modal
        open={openModal}
        onClose={handleClickCloseModal}
        title="RNTRC"
        buttons={{ primary: modalButton }}
      >
        <>
          <Styled.ModalChildSubtitle>O que é RNTRC?</Styled.ModalChildSubtitle>
          <Styled.ModalChildMessage>
            Registro emitido pela ANTT que passou a ser obrigatório para todos que
            realizam transporte remunerado de cargas no país.
          </Styled.ModalChildMessage>
          <br />
          <Styled.ModalChildSubtitle>
            Onde acho o número do RNTRC?
          </Styled.ModalChildSubtitle>
          <Styled.ModalChildMessage>
            O número fica disponível na carteirinha da ANTT do veículo.
          </Styled.ModalChildMessage>
          <Styled.AnttCard>
            <Styled.AnttCardFront />
            <Styled.AnttCardOr>OU</Styled.AnttCardOr>
            <Styled.AnttCardBack />
          </Styled.AnttCard>
        </>
      </Modal>
    </>
  )
}

export default Rntrc
